import React from 'react';

import { FormComponent } from 'components';
import { SearchAdditionalFilterType } from 'types';

interface Props {
  filter: SearchAdditionalFilterType;
  handleFilter: (filter: SearchAdditionalFilterType) => void;
}

function Filter({ handleFilter }: Props) {
  return (
    <FormComponent.Form submit={handleFilter}>
      <FormComponent.SearchInput
        name="title"
        placeholder="타이틀로 검색해주세요"
      />
    </FormComponent.Form>
  );
}

export default Filter;
